<section>
  <div class="row mt-2 mb-2">
    <div class="col-xl-6 col-lg-6 col-md-6 col-sm-6 col-xs-12">
      <div class="content-header f_20 module-header ml-2 mt-18px">My Wallet</div>
    </div>
    <div class="col-xl-6 col-lg-6 col-md-6 col-sm-6 col-xs-12">
      <button class="btn btn-primary mt-2 pull-right mr-2" (click)="navigateTo('users/wallet/my-wallet/transaction-history')">
        My Wallet Transactions
      </button>
    </div>
  </div>
  <div class="row p-sm-2 d-none d-md-block">
    <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">
      <table class="table table-list overflow-x-scroll">
        <thead>
        <tr>
          <th class="text-center"><h6 class="mt-1 mb-1 font-weight-bold">S.No</h6></th>
          <th class="text-center"><h6 class="mt-1 mb-1 font-weight-bold">Wallet</h6></th>
          <th class="text-center"><h6 class="mt-1 mb-1 font-weight-bold">Amount</h6></th>
        </tr>
        </thead>
        <tbody *ngIf="myWallets && myWallets.length > 0; else noDataToShowWeb">
        <tr *ngFor="let myWallet of myWallets; let i = index">
          <td class="text-center">
            <h6 class="mt-1">{{i + 1}}.</h6>
          </td>
          <td class="text-center"><h6 class="mt-1">{{myWallet?.wallet}}</h6></td>
          <td class="text-center"><h6 class="mt-1">{{myWallet?.amount}}</h6></td>
        </tr>
        </tbody>
        <ng-template #noDataToShowWeb>
          <tbody>
          <tr>
            <td colspan="4" class="text-center"><h6>No data to show</h6></td>
          </tr>
          </tbody>
        </ng-template>
      </table>
    </div>
  </div>

  <div class="row d-block d-md-none" *ngIf="myWallets && myWallets.length > 0; else noDataToShowMobile">
    <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">
      <div class="card" *ngFor="let myWallet of myWallets; let i = index">
        <div class="card-header bottom-shadow-light pb-18px">
          <div class="row">
            <div class="col-12">
              <h4 class="card-title text-uppercase card-ellipsis pb-3">{{i + 1}}. {{myWallet?.wallet}}</h4>
            </div>
          </div>
        </div>
        <div class="card-body">
          <div class="row p-2">
            <div class="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-xs-12 mt-1">
              Amount - {{myWallet?.amount}}
            </div>
            <div class="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-xs-12 mt-1">
              Registration Date - {{myWallet?.registration_date}}
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <ng-template #noDataToShowMobile>
    <div class="row d-block d-md-none">
      <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">
        <div class="card text-center">
          <h5 class="p-5">No data to show</h5>
        </div>
      </div>
    </div>
  </ng-template>
</section>
